import { useState } from "react";
import { LoadingOutlined, MenuOutlined } from "@ant-design/icons";
import { Avatar, Col, Drawer, Grid, Row, Typography } from "antd";
import { Spin } from "antd";
import { SettingFilled } from "@ant-design/icons";
import { ConsumerDashboardMenu } from "components/ConsumerDashboard/ConsumerDashboardMenu";
import classes from "./styles/ConsumerDashboardContainer.module.css";
import docClasses from "../components/Panel/Admin/Documents/DocumentDisplay.module.css";
import { useGetIdentity, useNavigation } from "@refinedev/core";
import { UserIdentityData } from "types/props";

export const ConsumerDashboardContainer = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { data: user } = useGetIdentity<UserIdentityData>();
  const { push } = useNavigation();

  const [visible, setVisible] = useState(false);
  const { md, lg } = Grid.useBreakpoint();
  const handleClick = (key: string) => {
    if (key.split("__")[0] === "doc") {
      push(`/documentation/${key.split("__")[1]}`);
    }
    switch (key) {
      case "1":
        push("/jobs");
        break;

      case "2":
        push("/playground");
        break;
      case "4":
        setVisible(true);
        break;
    }
  };

  if (!user?.role) {
    return (
      <Row>
        <Row className={classes.LoadingContainer} justify={"center"} align="middle">
          <Spin
            spinning
            size="large"
            indicator={<LoadingOutlined style={{ fontSize: 48, color: "white" }} spin />}
          />
        </Row>
      </Row>
    );
  }

  return (
    <Row className={classes.ConsumerDashboardContainer}>
      <Drawer
        visible={true}
        placement="left"
        className={classes.SidebarDrawer}
        mask={false}
        width={lg ? 300 : md ? 250 : 150}
        size="default"
        autoFocus={false}
        style={{
          textAlign: "left",

          backgroundColor: "#1A1D38"
        }}
        bodyStyle={{
          backgroundColor: "#1A1D38"
        }}
        closable={false}>
        <div style={{ padding: "32px 12px 0 8px" }}>
          <Row>
            <Col span={12}>
              {" "}
              <Avatar className={classes.avatar}>
                {user?.firstName?.charAt(0)?.toUpperCase()}
              </Avatar>
            </Col>
            <Col span={12}>
              <SettingFilled
                style={{ fontSize: "18px" }}
                onClick={() => {
                  push("/settings/account");
                }}
                className={classes.settingsIcon}
              />
            </Col>
          </Row>

          <Typography.Text ellipsis className={classes.FullName} style={{ marginTop: "12px" }}>
            {user?.firstName} {user?.lastName}
          </Typography.Text>
        </div>
        <div>
          <ConsumerDashboardMenu handleClick={handleClick} />
        </div>
      </Drawer>
      <Col
        xs={{ span: 5 }}
        sm={{ span: 5 }}
        md={{ span: 6 }}
        lg={{ span: 6 }}
        xl={{ span: 5 }}></Col>
      <Col
        className={classes.ConsumerDashboardMainbar}
        xs={{ span: 19 }}
        sm={{ span: 19 }}
        md={{ span: 18 }}
        lg={{ span: 18 }}
        xl={{ span: 19 }}>
        <div className={classes.ConsumerDashboardMainContent}>
          <MenuOutlined
            style={{ fontSize: "2rem" }}
            // onClick={() => setVisible((prev) => !prev)}
          />
        </div>
        <div className={docClasses.docsContainer}>{children}</div>
      </Col>
    </Row>
  );
};
